import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import ProfileListItem from './ProfileListItem';

export default class ProfileList extends Component {
  constructor(props) {
    super(props);
    this.renderList = this.renderList.bind(this);
  }
  
  renderList() {
    const {
      device,
      profiles,
      isRankType,
      useRenderCount,
      renderCount,
      reduxProfileNames
    } = this.props;
    return (
      <ul className="list_plus">
        {profiles.map((profile, idx) => {
          if (useRenderCount && idx >= renderCount) {
            return null;
          }
          return (
            <ProfileListItem
              device={device}
              key={idx}
              index={idx}
              profile={profile}
              isRankType={isRankType}
              reduxProfileNames={reduxProfileNames}
            />
          );
        })}
      </ul>
    );
  }
  
  render () {
    const { profiles, title, isNoTitle, titleLink, subTitle, emptyMessage } = this.props;
    if (profiles.size == 0) {
      if (!isEmpty(emptyMessage)) {
        return (
          <div className="list_coupon">
            <p className="desc_empty">{emptyMessage}</p>
          </div>
        );
      }
      return null;
    }
    const hasLink = !isEmpty(titleLink);
    const hasSubTitle = !isEmpty(subTitle);
    return (
      <div>
        {!isNoTitle && hasLink && (
          <h4 className="tit_box">
            <a href={titleLink} className="link_tit">{title}<span className="ico_plus ico_arr" /></a>
          </h4>
        )}
        {!isNoTitle && !hasLink && (
          <div className="tit_box">
            <h4 className="link_tit">{title}</h4>
            {hasSubTitle && (<span className="txt_time">{subTitle}</span>)}
          </div>
        )}
        {this.renderList()}
      </div>
    );
  }
}

ProfileList.propTypes = {
  device: PropTypes.object.isRequired,
  profiles: PropTypes.object.isRequired,
  isNoTitle: PropTypes.bool,
  title: PropTypes.string,
  titleLink: PropTypes.string,
  isRankType: PropTypes.bool,
  useRenderCount: PropTypes.bool,
  renderCount: PropTypes.number,
  subTitle: PropTypes.string,
  emptyMessage: PropTypes.string,
  reduxProfileNames: PropTypes.array
};

ProfileList.defaultProps = {
  isNoTitle: true,
  title: '',
  titleLink: '',
  isRankType: false,
  useRenderCount: false,
  renderCount: 20,
  subTitle: '',
  emptyMessage: '',
  reduxProfileNames: []
};


// WEBPACK FOOTER //
// ./src/components/ProfileList/index.js